export enum PaymentTermsPermissions {
  VIEW_PAYMENT_TERMS = "view_payment_terms",
  CREATE_PAYMENT_TERMS = "create_payment_terms",
  UPDATE_PAYMENT_TERMS = "update_payment_terms",
  DELETE_PAYMENT_TERMS = "delete_payment_terms",
  ARCHIVE_PAYMENT_TERMS = "archive_payment_terms",
}

export const PaymentTermsPermissionsText: Record<
  PaymentTermsPermissions,
  string
> = {
  [PaymentTermsPermissions.VIEW_PAYMENT_TERMS]: "View Payment Terms",
  [PaymentTermsPermissions.CREATE_PAYMENT_TERMS]: "Create Payment Terms",
  [PaymentTermsPermissions.UPDATE_PAYMENT_TERMS]: "Update Payment Terms",
  [PaymentTermsPermissions.DELETE_PAYMENT_TERMS]: "Delete Payment Terms",
  [PaymentTermsPermissions.ARCHIVE_PAYMENT_TERMS]: "Archive Payment Terms",
};
